import React from 'react';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import FieldObject from './field_object';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_search.form.sections.candidate.labels');

type Props = {
  fieldObject: FieldObject;
  onUpdate: (val: FieldObject) => void;
};

const TextOption = ({ fieldObject, onUpdate }: Props) => {
  const fieldLabel = fieldObject.fieldLabel();
  const value = fieldObject.selection as string;

  const onTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    fieldObject.setSelection(e.target.value);
    onUpdate(fieldObject);
  };

  return (
    <TextInput
      id={fieldLabel}
      label={t('search_option', { option: fieldLabel })}
      value={value}
      onChange={onTextFieldChange}
    />
  );
};

export default TextOption;
